module.exports = __webpack_public_path__ + "static/media/icon-money-1.e18862b4.svg";